import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../constants/env";

const useAuthRedirect = () => {
  const [slotData, setSlotData] = useState(null);

  useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await axios.get(`${env.apiUrl}/api/user/slots`);
        setSlotData(response.data);
      } catch (err) {
        console.error("Failed to fetch slot data:", err);
      }
    };

    fetchSlotData();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("userToken");
    const secureSpot = params.get("secure_spot");
    const page = params.get("page"); // 🔥 NEW

    if (!token) return;

    // Save the token
    localStorage.setItem("userToken", token);

    // ⭐ NEW: Check if user came from Arena login
    // if (page === "arena") {
    //   window.location.href = "/arena";
    //   return;
    // }

    // Existing logic
    if (secureSpot === "true" && slotData?.availableSlots > 0) {
      window.location.href = "/trading?secure_spot=true";
    } else {
      window.location.href = "/trading";
    }
  }, [slotData]);
};

export default useAuthRedirect;
